module.exports = __webpack_public_path__ + "img/img-fastfood-1.561e15f3.jpg";